import type { SanityHomepageEvents } from '#/lib/sanity/queries/homepageEvents';
import { cn } from '#/lib/utils';
import { Button } from '#/components/Button';
import { EventCard } from '#/components/EventCard';
import { formatHeadline } from '#/components/Headline';

export function HomepageEvents(props: SanityHomepageEvents) {
  if (!props.events.length) return null;

  const count = props.events.length;
  const isFeatured = count === 1;

  return (
    <div className="bg-grayscale-01 p-main py-40 m:py-80 l:py-100">
      <div className="fade-in mx-auto flex max-w-1235 flex-col gap-48">
        <div className="flex flex-col gap-32 m:gap-48">
          <h2 className="type-heading5 m:type-heading3 max-w-[800px] text-balance text-charcoal">
            {formatHeadline(props.headline)}
          </h2>
          {props.link?.href ? (
            <Button
              href={props.link.href}
              target={props.link.target}
              variant="link"
              className="block w-full text-current m:w-auto"
            >
              {props.link.title}
            </Button>
          ) : null}
        </div>
        <div
          className={cn(
            'grid grid-cols-1 gap-24',
            count === 2 && 'm:grid-cols-2',
            count >= 3 && 'm:grid-cols-2 l:grid-cols-3',
          )}
        >
          {props.events.map((event) => (
            <EventCard
              key={event._id}
              event={event}
              variant={isFeatured ? 'featured' : 'homepage'}
              mediaSizes={
                isFeatured
                  ? { m: '50vw', '1285px': '618px' }
                  : count === 2
                    ? { m: '50vw', '1285px': '600px' }
                    : { m: '50vw', l: '33vw', '1285px': '412px' }
              }
            />
          ))}
        </div>
      </div>
    </div>
  );
}
